import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileRedact = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M20 10V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5M8 8.5h2" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 4.5,
			x: 7,
			y: 11.5,
			fill: "currentColor",
			stroke: "none",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 19h4" })
	]
});
const Memo = memo(SvgFileRedact);
export default Memo;
